import { validators } from 'config';
import { map } from 'lodash';
import { Buffer } from 'buffer';
import * as XLSX from 'xlsx';
import SimpleCrypto from 'simple-crypto-js';
import { currency_symbols } from 'config';

export const textFormatter = value => {
	if (typeof value === 'string') {
		const val = value?.replace(/_/g, ' ');
		return val?.charAt(0)?.toUpperCase() + val?.slice(1)?.toLowerCase();
	} else {
		return value;
	}
};

export const emailValidationRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const getValuesById = (array, id) => {
	const a = array ? array?.filter(el => el?.key === id) : null;
	return a;
};

export const getValueMtpl = (array, data, dataKey) => {
	const a = [];
	array?.map(el => {
		data?.map(e => {
			dataKey ? el?.key === e?.[dataKey] && a.push(el) : el?.key === e && a.push(el);
		});
	});
	return a;
};

export const getValueById = (array, id) => {
	const a = array ? array?.find(el => el?.key === id) : null;
	return a;
};

export const dateDropDown = obj => {
	return obj?.map(el => ({ id: el?.name, value: el?.value }));
};

export const checkIfNullOrVal = value => {
	value = typeof value === 'string' ? value.trim() : value;
	return value === 'NULL' || value === '' || value === ' ' || value === undefined || value === null ? null : value;
};

export const requestValidator = params => {
	let error = false;
	validators[params?.validatorKey]?.forEach(el => {
		if (!checkIfNullOrVal(params[el])) {
			error = true;
		}
	});
	return error;
};

// xlsx convertor
export const xlsxConvertorFunc = data => {
	const workbook = XLSX.read(data, { type: 'binary' });
	const list = map(workbook.SheetNames, sheet => XLSX.utils.sheet_to_json(workbook.Sheets[sheet], { raw: true, defval: null }));
	return list[0];
};

// .csv to JSON convertor
export const csvJSON = (csv, _char) => {
	const lines = csv.split('\n');
	return lines[0].split(_char);
};

// csv to json object
export const csvArray = csv => {
	const lines = csv.split('\n');
	const result = [];
	const headers = lines[0].split(',');
	for (let i = 1; i < lines.length; i++) {
		const obj = {};
		const currentline = lines[i].split(',');
		for (let j = 0; j < headers.length; j++) {
			obj[headers[j]] = currentline[j]?.toString()?.replace(/[`\[\];\'\'\/\\\?]/g, '');
		}
		result.push(obj);
	}
	return result;
};

// file reader
export const fileReader = obj => {
	const reader = new FileReader();
	let fileData;
	reader.readAsBinaryString(obj);
	reader.onload = () => {
		fileData = reader.result;
		return fileData;
	};
};

export const colName = n => {
	const ordA = 'A'.charCodeAt(0);
	const ordZ = 'Z'.charCodeAt(0);
	const len = ordZ - ordA + 1;

	let s = '';
	while (n >= 0) {
		s = String.fromCharCode((n % len) + ordA) + s;
		n = Math.floor(n / len) - 1;
	}
	return s;
};

export const fileDownload = (data, fileName) => {
	const buff = Buffer.from(data).toString();
	const blob = new Blob([buff], { type: 'csv' });
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = `${fileName + 'File'}.${'csv'}`;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
};

export const isValidUrl = urlString => {
	try {
		return Boolean(new URL(urlString));
	} catch (e) {
		return false;
	}
};

export const dropDown = (e, arr) => {
	const dropdown = arr?.find(el => el.key === e)?.value;
	return dropdown;
};

// decrypt data
export const decrypting = data => {
	const _sc = localStorage.getItem('_sc');
	if (_sc) {
		const simpleCrypto = new SimpleCrypto(_sc);
		const decrypt = data ? simpleCrypto.decrypt(data) : '';
		return decrypt;
	}
};

// encrypt data
export const encrypting = data => {
	const _sc = localStorage.getItem('_sc');
	if (_sc) {
		const simpleCrypto = new SimpleCrypto(_sc);
		try {
			const decrypt = data ? simpleCrypto.encrypt(data) : '';
			return decrypt;
		} catch (error) {}
	}
};

export const arrayBufferToBlob = (buffer, state, fileName, type) => {
	let binary = '';
	const bytes = new Uint8Array(buffer);
	const len = bytes.byteLength;
	for (let i = 0; i < len; i++) {
		binary += String.fromCharCode(bytes[i]);
	}
	const file = window.btoa(binary);
	const mimType = type === 'pdf' ? 'application/pdf' : 'application/csv';
	const url = `data:${mimType};base64,` + file;
	if (state === 'download') {
		const a = document.createElement('a');
		a.href = url;
		a.download = fileName;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		window.URL.revokeObjectURL(url);
	} else {
		const byteCharacters = atob(file);
		const byteArrays = [];
		for (let offset = 0; offset < byteCharacters.length; offset += 512) {
			const slice = byteCharacters.slice(offset, offset + 512),
				byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}
			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}
		const blob = new Blob(byteArrays, { type: 'application/pdf' });
		const objectURL = URL.createObjectURL(blob) + '#toolbar=0&navpanes=0&scrollbar=0';
		return objectURL;
	}
};

export const amountFormatter = (value, currencyCode) => {
	const currencySymbol = currencyCode ? currency_symbols[currencyCode] : '';
	return (
		(currencySymbol || '') +
		parseFloat(value?.toFixed(2))
			?.toString()
			?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	);
};
